/*
 * @Date: 2020-03-09 17:45:30
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 14:25:40
 * @FilePath: /rongxin.web/src/components/navbar/index.js
 */
export default {
  name: 'navbar',
  props: {
    formDetail: {
      type: Boolean,
      default: false
    },
    fromisActiveClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isActiveClass: 'home'
    };
  },
  created() {
    // console.log(this.$route, 'this.$route');
    // this.goDetail(this.$route.name, this.$route.name);
    // 来自二级、三级页面
    if(this.fromisActiveClass) {
      this.isActiveClass = this.fromisActiveClass;
    }
  },
  methods: {
    goDetail(activeClass, paths) {
      // console.log(activeClass, paths);
      this.$router.push({path: '/' + paths});
      this.isActiveClass = activeClass;
    }
  }
};
